import Chart from "react-apexcharts";
import "./pieChart.css";
import * as React from "react";
import Box from "@mui/material/Box";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import { useState, useEffect } from "react";
import { OutlinedInput } from "@mui/material";
import axios from "axios";
import Cookies from "universal-cookie";
import { useNavigate } from "react-router-dom";
import { Logger } from "../../../Logger/Logger";

const status_name = ["severity", "status"];
const PieChart = () => {
  const navigate = useNavigate();
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const [age, setAge] = useState("status");
  const [data, setData] = useState({});
  const cookies = new Cookies();
  const apiKey = cookies.get("UserLogin");
  useEffect(() => {
    getListStatus();
  }, []);

  const getListStatus = () => {
    axios
      .get(`${BASE_URL}api/dashboard/ticket_count_by_status/`, {
        headers: { Authorization: `Bearer ${apiKey}` },
      })
      .then((res) => {
        setData(res.data.data);
      })
      .catch((error) => {
        Logger.error("error in ticket count status", error);
        if (error.response.status == 403) {
          cookies.remove("UserLogin");
          cookies.remove("UserDetails");
          cookies.remove("adminRole");
          cookies.remove("sysAdminRole");
          cookies.remove("createdBy");
          cookies.remove("UserLoginAccessToken");
          cookies.remove("UserName");
          navigate("/");
        }
        if (error.response.status == 404) {
          navigate("/*");
          setTimeout(() => {
            navigate("/secured/empDashboard");
          }, 5000);
        }
      });
  };
  const getListSeverity = () => {
    axios
      .get(`${BASE_URL}api/dashboard/ticket_count_by_severity/`, {
        headers: { Authorization: `Bearer ${apiKey}` },
      })
      .then((res) => {
        setData(res.data.data);
      })
      .catch((error) => {
        Logger.error("error in ticket count severity", error);

        if (error.response.status == 403) {
          cookies.remove("UserLogin");
          cookies.remove("UserDetails");
          cookies.remove("adminRole");
          cookies.remove("sysAdminRole");
          cookies.remove("createdBy");
          cookies.remove("UserLoginAccessToken");
          cookies.remove("UserName");
          navigate("/");
        }
        if (error.response.status == 404) {
          navigate("/*");
          setTimeout(() => {
            navigate("/secured/empDashboard");
          }, 5000);
        }
      });
  };

  Logger.debug("data in piechart", data);
  const handleChange = (event) => {
    if (event.target.value === "severity") {
      setAge("severity");
      getListSeverity();
    }
    if (event.target.value === "status") {
      setAge("status");
      getListStatus();
    }
  };

  return (
    <div className="piechartcontainer">
      {data.Open > 0 ||
        data.Closed > 0 ||
        data.Resolved > 0 ||
        data["In Progress"] > 0 ||
        data.High > 0 ||
        data.Low > 0 ||
        data.Medium > 0 ? (
        <>
          <Chart
            type="pie"
            width={"100%"}

            series={Object.values(data)}
            options={{
              colors: ["#008FFB", "#25B396", "#2D033B", "#FF4560"],
              labels: Object.keys(data),
              dataLabels: {
                enabled: true,
                background: {
                  foreColor: "#fff"
                }
              },
              legend: {
                display: true,
                position: "right",
              },
            }}
            className="piechart123"
          ></Chart>
          <Box sx={{ textTransform: "capitalize" }}>
            <FormControl fullWidth>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                value={age}
                input={<OutlinedInput />}
                label="Select"
                onChange={handleChange}
                sx={{ height: 40 }}
              >
                {status_name.map((item) => (
                  <MenuItem
                    key={item}
                    style={{ textTransform: "capitalize" }}
                    value={item}
                  >
                    {item}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </Box>
        </>
      ) : (
        <span>No records to display</span>
      )}
    </div>
  );
};
export default PieChart;
